





$(document).on('click', '.p-header__btn-link', function(e) {
    e.preventDefault();
    promokit.message({
        type: 'alert',
        message: '자세한 내용은 추후 공개됩니다.',
    });
});

$(document).on('click', '.p-sec1__btn-link', function(e) {
    location.href = 'https://lineagem.plaync.com/board/event/view?articleId=50038854'
});

$(document).on('click', '.p-sec2__btn', function(e) {
    location.href = 'https://lineagem.plaync.com/board/event/view?articleId=50038853'
});


$(document).on('click', '.p-banner__btn-close', function(e) {
    $('.p-banner').remove();
});

let video1 = promokit.youtube({
    el: '#player-1',
    youtubeid: 'nitT9yYMcPs',
    preload: true,
    controls: true,
    youtubeLink:true
});

let layer1 = promokit.layer({
    el: '#layer-1',
    render: true,
    autoplayVideo: video1,
    buttons: '.p-list__btn-layer'
});



let page = promokit.page({
    type: 'basic',
    game: 'lineagem',
    caution: '#section-caution',
    cnb: true, //true, false
    topButton: true, //true, false
    headerButton: {
        el: '.header-button',
        cookie: false,
        home: true,
        event: true,
        update: false,
        sns: true,
        theme: 'black' //'black', 'white'
    },
    footer: {
        theme: 'white' //'black', 'white'
    },
    remote: {
        title: '기사의 전당',
        home: true,
        coupon: false,
        template: `<ul>
                  <li><a href="#section-1">명예의 기사</a></li>
                  <li><a href="#section-2">역전의 기사</a></li>
                  <li><a href="#section-3">SNS공유 이벤트</a></li>
                  <li><a href="/update/2020/201111_update">기사도 업데이트</a></li>
                </ul>`
    }
});








// WEBPACK FOOTER //
// ./src/js/index.js